<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-table-header">
          <PageHeader :page-title="'Partners Telegram'">
            <template v-slot:buttons>
              <b-button
                class="button title-container__controls-item"
                :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter"
              >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
            </template>
          </PageHeader>

          <Filters
            v-show="isShowFilter"
            textButtonSubmit="Filter"
            :data="getTableFilters"
            :isLoading="isDataPageLoading"
            @submit="setFilters"
          />
          <TableForPage
            ref="table"
            :tableData="getTableData"
            :fields="getTableFields"
            :perPage="getPartnerTelegrams.per_page"
            :currentPage="getPartnerTelegrams.current_page"
            :totalRows="getPartnerTelegrams.total"
            :actions="getTableActions"
            isServerRender
            noLocalSorting
            @remove="remove"
            @edit="showEditModal"
            @update="updateList"
          />
        </div>
      </div>
    </div>

    <EditePartnerTelegramModal
      v-model="editModal.show"
      :form="editModal.form"
      @save="edit"
    />
  </div>
</template>

<script>
import PageHeader from '@components/PageHeader'
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import { mapGetters } from 'vuex'
import TelegramPartnersMixin from '@mixins/notifications/TelegramPartnersMixin'
import EditePartnerTelegramModal from '@components/modals/Telegram/EditePartnerTelegramModal'

export default {
  mixins: [TelegramPartnersMixin],
  components: {
    PageHeader,
    EditePartnerTelegramModal,
    Filters,
    TableForPage
  },
  data () {
    return {}
  },
  created () {
    this.fetchAllData()
  },
  computed: {
    ...mapGetters({
      getPartnerTelegrams: 'telegram/getPartnerTelegrams'
    }),
    getTableFilters () {
      return this.filters || {}
    },
    getTableFields () {
      return this.table.fields || []
    },
    getTableActions () {
      return this.table.actions || []
    },
    getTableData () {
      return this.getPartnerTelegrams.data || []
    }
  },
  methods: {
    fetchAllData () {
      return Promise.all([
        this.fetchList()
      ])
    },
    fetchList () {
      let params = this.table.params.currentPage
      if (this.table.params.sorting) {
        params += this.table.params.sorting
      }
      if (this.table.params.filters) {
        params += this.table.params.filters
      }
      return this._toggleDataPageLoading(() => this.$api.telegram.getPartnerTelegrams(params))
    },
    updateList (data) {
      if (!data) return this.fetchList()

      const { currentPage, sortDesc, sortBy } = data
      this.setParamsCurrentPage(currentPage)
      this.setParamsSort(sortDesc, sortBy)
      this.fetchList()
    },
    setFilters (data) {
      this.setParamsFilters(data)
      this.setParamsCurrentPage()
      this.fetchList()
    },
    edit (data) {
      const partnerTelegram = {
        partner_id: this.editModal.partnerId,
        ...this.prepareDataForRequest(data)
      }
      this.$api.telegram.editPartnerTelegram(partnerTelegram)
        .then(() => {
          this.$snotify.success('Partner telegram successfully edited', 'Success', this.$store.state.snotify)
          this.hideEditModal()
          this.fetchList()
        }).catch(err => {
          const errors = Object.values(err.response.data.errors)
          for (let i = 0; i < errors.length; i++) {
            this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
          }
        })
    },
    async remove (item) {
      const confirm = await this.$root.$confirm.open(
        'Reset',
        'Are you sure you want to reset the partner telegram?'
      )

      if (!confirm) return

      this._toggleDataPageLoading(async () => {
        const deleteResponse = await this.$api.telegram.removePartnerTelegram(item.partnerId)
        this.$snotify.success(
          deleteResponse.data,
          'Success',
          this.$store.state.snotify
        )
        this.updateList()
      })
    }
  }
}
</script>

<style>

</style>
